export default "__VITE_ASSET__8kR2$oDu__"